import { render } from "./Feedbackbar.vue?vue&type=template&id=0cd1bc6e&scoped=true"
import script from "./Feedbackbar.vue?vue&type=script&lang=js"
export * from "./Feedbackbar.vue?vue&type=script&lang=js"

import "@/css/components/feedbackbar.css?vue&type=style&index=0&id=0cd1bc6e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd1bc6e"]])

export default __exports__